import {CouponError} from '../../../../../domain/services/CartService';

export function getTooltipErrorMessageOptions(couponError: CouponError) {
  switch (couponError.code) {
    case 'ERROR_INVALID_SUBTOTAL':
      return {subtotal: couponError.message};
    case 'ERROR_INVALID_PRODUCT_QUANTITY':
      return {quantity: couponError.message};
    default:
      return {};
  }
}
